import { type ICreateExternalCouponWagerUseCase, type IWagerClientService } from '../../../domain/entry.js';

/**
 * Use case for creating an external wager based on a provided coupon.
 *
 * @param wagerClientService Wager service dependency
 * @returns Use case executor for creating external wagers
 */
export function createExternalCouponWagerUseCase(
  wagerClientService: IWagerClientService
): ICreateExternalCouponWagerUseCase {
  return {
    execute: async ({
      coupon,
      wallets,
      couponIndex,
      showDialog,
      paymentContext,
    }): ReturnType<ICreateExternalCouponWagerUseCase['execute']> => {
      const wagerPaymentResponse = await wagerClientService.createWagerAsync([coupon], {
        wallets,
        couponIndices: [couponIndex],
        showDialog,
        paymentContext,
      });

      return wagerPaymentResponse;
    },
  };
}
